const filterListByThemes = (list, filters) => (
  !filters
  || (filters?.length === 1 && filters[0].id === 0)
    ? list
    : list
      ?.filter((el) => el.themes.filter((t) => filters?.find((e) => e.id === t.id)).length));

export default filterListByThemes;
